// extracted by mini-css-extract-plugin
module.exports = {"section":"home-module--section--207bF"};